import LMSDispatcher from "../../LMSDispatcher";
import { EventEmitter } from "events";

import * as ACTIONCONSTANTS from "../../actions/ActionConstants";
import IDirectionData from "../../../models/direction/directionData";

interface IDirectionList {
    state: {
        directionDataList?: IDirectionData[]
    }
}

class ListStore extends EventEmitter implements IDirectionList {

    state: {
        directionDataList?: IDirectionData[] | undefined;
    };

    constructor() {
        super();

        this.state = {
            directionDataList: []
        }

        LMSDispatcher.register((e: any) => {
            switch (e.type) {
                case ACTIONCONSTANTS.DIRECTION_LIST:
                    Object.assign(this.state, e.payload);
                    this.emit('change', this.state);
                    break;
            }
        });
    }
}

const directionListStore = new ListStore();

export default directionListStore;